export const GLOBAL = {
    PAYMENT_PORT: {
        STEP: {
            ERROR: -1,
            SEARCH: 1,
            RECEIPT_INFO: 2,
            // Mã định danh
            STUDENT_ID_INFO: 3,
            PAYMENT_INFO: 4,
            ONEPAY_QRCODE: 5,
        },
        PROVIDER: {
            ONEPAY: 1,
            PAYOO: 2,
            YSCHOOL: 3,
            VNPT_EPAY: 4,
            NINE_PAY: 5,
        },
        PROVIDER_NAME: {
            ONEPAY: 'OnePay',
            PAYOO: 'Payoo',
            YSCHOOL: 'Yschool',
            VNPT_EPAY: 'VNPT EPAY',
            NINE_PAY: '9PAY',
        },
        PROVIDER_CLASS_ICON: {
            ONEPAY: 'onepay',
            PAYOO: 'payoo',
            YSCHOOL: 'yschool',
            VNPT_EPAY: 'epay',
            NINE_PAY: 'ninepay',
        },
        CARD_TYPE: {
            ATM: 1,
            VISA_MASTER: 2,
            E_WALLET: 3,
            TRANSFER: 4,
            QR_CODE: 40001,
        },
        CARD_TYPE_CLASS_ICON: {
            ATM: 'atm',
            VISA_MASTER: 'master',
            E_WALLET: 'ewallet',
            TRANSFER: 'transfer',
            QR_CODE: 'qrcode',
        },
    },
};
